import React from 'react';
import { Box } from '@mui/material';
import { MailOutline, PhoneInTalkOutlined } from '@mui/icons-material';
import { ContactInfoRow } from '../../../../../molecules';
import { ContactType } from '@uplift/api';
import { Loader } from '../../../../../Loader';
import { useProviderContacts } from './ProviderCardContacts.hooks';
import { useUserQuery } from '@uplift/queries';
import { ProviderMedicalRole } from '@uplift/types';


const contactTypeToIconMap = {
  [ContactType.email]: MailOutline,
  [ContactType.phone]: PhoneInTalkOutlined,
};


export type ProviderCardContactsProps = {
  providerId?: string;
  medicalRole?: ProviderMedicalRole;
  visible?: boolean;
};

export const ProviderCardContacts: React.VFC<ProviderCardContactsProps> = ({
  providerId,
  visible = true,
  medicalRole
}) => {
  const { data: contacts, isLoading: isContactsLoading } = useProviderContacts(providerId, visible);
  const emailContact = React.useMemo(() => {
    const emailContactIndex = contacts?.findIndex(c => c.name === 'email');

    if (emailContactIndex === null || emailContactIndex === undefined) {
      return null;
    }

    return emailContactIndex > -1;
  }, [ contacts ]);

  const { data: matchedProvider, isInitialLoading: isProviderLoading } = useUserQuery(providerId, {
    enabled: visible,
  });

  if (isContactsLoading || isProviderLoading) {
    return (
      <Loader height="72px" size="24px" color="secondary" />
    );
  }

  const shouldShowAccountEmail = matchedProvider && (
    medicalRole === ProviderMedicalRole.psychiatrist
    || !emailContact
  );

  const displayContacts = shouldShowAccountEmail
    ? contacts?.filter(x => x.name !== 'email')
    : contacts;

  return (
    <Box px={2} py={1} display="flex" flexDirection="column" gap="8px">
      {shouldShowAccountEmail && (
        <ContactInfoRow
          key="email"
          icon={contactTypeToIconMap[ContactType.email]}
          primary={matchedProvider.email}
          secondary="email"
          text={matchedProvider.email}
        />
      )}
      {displayContacts?.map(contact => (
        <ContactInfoRow
          key={contact.id}
          icon={contactTypeToIconMap[contact.type]}
          primary={contact.value}
          secondary={contact.name}
          text={contact.value}
        />
      ))}
    </Box>
  );
};
